angular.module('app.filters')
.filter('orderAddress', () =>
    function(input) {
        if (!input) {
            return '';
        }
        let addrStr = "";
        if (input.name) {
            addrStr += input.name + '\n';
        }
        if (input.company) {
            addrStr += input.company + '\n';
        }
        addrStr += (input.line1 + '\n');
        addrStr += `${input.city}, ${input.state} ${input.postal_code} ${input.country}`;
        return addrStr;
    }
);



// WEBPACK FOOTER //
// ./filters/order_address.js